import { Model, ModelsService } from '../api';

interface ModelsProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Model[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: Model }>;
  getOne: (resource: string, params: any) => Promise<{ data: Model }>;
  update: (resource: string, params: any) => Promise<{ data: Model }>;
  getMany: (resource: string, params: any) => Promise<{ data: Model[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Model[] }>;
}

export const modelsProvider: ModelsProviderResource = {
  getList: async (resource, params) => {
    console.log('getList');
    console.log(params);
    const { items } = await ModelsService.listModel();
    console.log(items);
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  create: async (resource, params) => {
    console.log(params);
    const model = await ModelsService.modelAdd(params.data);
    return { data: model };
  },
  getOne: async (resource, params) => {
    const model = await ModelsService.getModel(params.id);
    return { data: model };
  },
  update: async (resource, params) => {
    console.log(params);
    const {
      data: { name, data_type, prompt, temperature },
    } = params;
    const model = await ModelsService.updateModel(params.id, {
      name,
      data_type,
      prompt,
      temperature,
    });
    return { data: model };
  },
  getMany: async (resource, params) => {
    console.log(resource);
    console.log(params);
    const ids = params.ids;
    console.log(ids);
    const data: Model[] = [];
    for (const id of ids) {
      const model = await ModelsService.getModel(id);
      data.push(model);
    }
    return { data: data };
  },
  getManyReference: async (resource, params) => {
    console.log(resource);
    console.log(params);
    return { data: [] };
  },
};
